import React, { useEffect, useState } from "react";
import DisenoChat from "./diseño-chat";
import axios from "axios";
import Box from "@mui/joy/Box";
import VentanaChat from "./componentesChat/chat.jsx";
import VentanaChatGrupal from "./componentesChat/chatgrupal/chatgrupal";
import { io } from "socket.io-client";
import { ChatContext } from "./componentesChat/mensajecontext";
import Alerta from "./alerta";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

export default function Amigos() {
  let [usuario, setusuario] = React.useState({
    foto_de_perfil: "",
    descripcion_perfil: "",
    nombre: "",
  });
  let [amigoSeleccionado, setAmigoSeleccionado] = React.useState({});
  let [amigos, setamigos] = React.useState([]);
  let [misaventuras, setMisAventuras] = React.useState([]);
  let [conversacion, setConversacion] = React.useState([]);
  let [idconversacion, setIdconversacion] = React.useState();
  let [aventuraSeleccionada, setAventuraSeleccionada] = React.useState();
  let [mensaje, setMensaje] = React.useState({
    id_amigo: "",
    mensaje: "",
    id_conversacion: "",
  });
  let [mensaje_grupal, setMensajeGrupal] = React.useState({
    mensaje: "",
    id_conversacion: "",
    id_actividad: "",
  });
  let [estadoAlerta, setestadoAlerta] = React.useState(false);
  let urlsocket = process.env.REACT_APP_FRONTEND_SOCKET;
  let url = process.env.REACT_APP_FRONTEND_URL;

  /* Compañeros y información de cuenta */

  async function callAmigos() {
    try {
      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");
      /* OBTENER BEARER TOKEN */
      let amigos = await axios.get(`${url}/api/amigos`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(amigos.data.amigos);
      setamigos(amigos.data.amigos);
      setusuario(amigos.data.usuario[0]);
    } catch (err) {
      console.log("Tenemos un Error al Obtener Amigos: " + err);
    }
  }

  useEffect(() => {
    callAmigos();
  }, []);

  /* Compañeros y información de cuenta */

  /* RECOGE AVENTURAS DEL USUARIO */

  async function callAventuras() {
    try {
      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");

      /* OBTENER BEARER TOKEN */

      let aventuras = await axios.get(
        `${url}/api/aventura/actividad-conversacion`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log(aventuras.data);
      setMisAventuras(aventuras.data);
    } catch (err) {
      console.log("tenemos un error al obtener las aventuras");
    }
  }

  useEffect(() => {
    callAventuras();
  }, []);

  /* RECOGE AVENTURAS DEL USUARIO */

  /* WEBSOCKET */
  /* Almacena las funciones del socket para poder enviar la información */
  let [socket, setSocket] = React.useState();
  /* Almacena las funciones del socket para poder enviar la información */
  /* CONEXION WEBSOCKET */

  useEffect(() => {
    /* OBTENER BEARER TOKEN */
    let token = localStorage.getItem("token");

    /* OBTENER BEARER TOKEN */

    let socket = io(`${urlsocket}`, {
      transports: ["websocket"],
      auth: { token },
    });
    console.log(socket);
    console.log("Estamos Conectados");
    // RECIBIR MENSAJE DEL SERVIDOR
    socket.on("respuesta", (data) => {
      console.log("Mensaje del servidor:", data);
    });

    // SELECCIONAR USUARIO Y CARGAR CONVERSACIÓN
    socket.on("seleccion_usuario", (data) => {
      if (data.chat.length > 0) {
        setConversacion(data);
        setIdconversacion(data.conversacionid);
        setMensaje((valoranterior) => ({
          ...valoranterior,
          id_conversacion: data.conversacionid,
        }));
      } else {
        setConversacion(data);
        setIdconversacion(data.conversacionid.id);
        setMensaje((valoranterior) => ({
          ...valoranterior,
          id_conversacion: data.conversacionid,
        }));
      }
    });

    // ENVIAR MENSAJE USUARIO INDIVIDUAL

    socket.on("mensaje", (data) => {
      socket.emit("seleccion_usuario", {
        id_amigo: data.id_amigo,
      });
    });

    /* CONVERSACIONES AVENTURAS */
    socket.on("conversacion_aventura", (data) => {
      setConversacion(data);
    });

    socket.on("mensaje_grupo", (data) => {
      socket.emit("conversacion_aventura", {
        idconversacion: data.idconversacion,
        idactividad: data.id_actividad,
      });
    });
    /* CONVERSACIONES AVENTURAS */

    // Limpiar conexión cuando el componente se desmonta

    socket.on("connect_error", (err) => {
      console.log("tenemos el siguiente error de conexión " + err);
    });

    setSocket(socket);
    return () => {
      socket.disconnect();
    };
  }, []); // Se ejecuta solo una vez al montar el componente

  /* CONEXION WEBSOCKET */
  /* WEBSOCKET */

  /* Selecciona Amigo del chat */
  function seleccionarAmigo(x) {
    callAmigos();
    setAmigoSeleccionado(x);
    setMensaje((valoranterior) => ({
      ...valoranterior,
      id_amigo: x.id,
    }));
    socket.emit("seleccion_usuario", {
      id_amigo: x.id,
    });
  }
  function elegirAventura(x) {
    callAventuras();
    setAventuraSeleccionada(x);
    setMensajeGrupal((valoranterior) => ({
      ...valoranterior,
      id_conversacion: x.id_conversacion,
      id_actividad: x.id_actividad,
    }));
    socket.emit("conversacion_aventura", {
      idconversacion: x.id_conversacion,
      idactividad: x.id_actividad,
    });
  }
  /* Selecciona Amigo del chat */

  /* Recibe el mensaje del cuadro de chat con usecontext de react */
  /* RECIBIR MENSAJE INDIVIDUAL */
  function recibirMensaje(x) {
    setMensaje((valoranterior) => ({ ...valoranterior, mensaje: x }));
  }
  /* RECIBIR MENSAJE INDIVIDUAL */

  /* RECIBIR MENSAJE GRUPAL */
  function recibirMensajeGrupal(x) {
    setMensajeGrupal((valoranterior) => ({ ...valoranterior, mensaje: x }));
  }
  /* RECIBIR MENSAJE GRUPAL */

  /* Recibe el mensaje del cuadro de chat con usecontext de react */

  /* MENSAJE INDIVIDUAL */
  function enviarMensaje() {
    let eliminaEspacios = mensaje.mensaje.trim();

    if (eliminaEspacios.length === 0) {
      setestadoAlerta(true);
      setMensaje((valoranterior) => ({
        ...valoranterior,
        mensaje: "",
      }));
      setTimeout(() => {
        setestadoAlerta(false);
      }, 3000);
    } else {
      socket.emit("mensaje", {
        mensaje,
      });
      setMensaje((valoranterior) => ({
        ...valoranterior,
        mensaje: "",
      }));
    }
  }
  /* MENSAJE INDIVIDUAL */

  /* MENSAJE GRUPAL */
  function enviarMensajeGrupal() {
    let eliminaEspacios = mensaje_grupal.mensaje.trim();

    if (eliminaEspacios.length === 0) {
      setestadoAlerta(true);
      setMensajeGrupal((valoranterior) => ({
        ...valoranterior,
        mensaje: "",
      }));
      setTimeout(() => {
        setestadoAlerta(false);
      }, 3000);
    } else {
      socket.emit("mensaje_grupo", {
        mensaje_grupal,
      });
      setMensajeGrupal((valoranterior) => ({
        ...valoranterior,
        mensaje: "",
      }));
    }
  }

  /* MENSAJE GRUPAL */

  /* FUNCIONALIDAD MOBIL */

  let [ocultar, setocultar] = React.useState(true);
  function ocultarDisenoChat() {
    setocultar(false);
  }
  function aparecerDisenoChat() {
    setocultar(true);
  }
  /* FUNCIONALIDAD MOBIL */

  return (
    <ChatContext.Provider
      value={{
        recibirMensaje,
        enviarMensaje,
        mensaje,
        recibirMensajeGrupal,
        enviarMensajeGrupal,
        mensaje_grupal,
        ocultarDisenoChat,
        aparecerDisenoChat,
      }}
    >
      <Alerta
        encendido={estadoAlerta}
        color="danger"
        startDecorator={<PriorityHighIcon />}
        contenido="No puedes enviar un mensaje vacío"
      />
      <Box>
        <Box sx={{ display: { xs: "none", md: "flex", lg: "flex" } }}>
          <DisenoChat
            misaventuras={misaventuras}
            amigos={amigos}
            funcion={seleccionarAmigo}
            selectaventura={elegirAventura}
            margin={80}
          />
          <Box sx={{ flexGrow: 1 }}>
            {conversacion.chatgrupal ? (
              <VentanaChatGrupal
                datoschat={conversacion}
                datosaventura={aventuraSeleccionada}
              />
            ) : (
              <VentanaChat
                foto_amigo={amigoSeleccionado.foto_de_perfil}
                nombre_amigo={amigoSeleccionado.nombre}
                edad={amigoSeleccionado.fecha_de_nacimiento}
                actividades={amigoSeleccionado.actividades}
                foto_usuario={usuario.foto_de_perfil}
                conversacion={conversacion}
              />
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: { xs: "block", md: "none", lg: "none" },
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              transition: "transform 0.5s ease, opacity 0.5s ease",
              transform: ocultar ? "translateX(0)" : "translateX(-100%)",
              opacity: ocultar ? 1 : 0,
              pointerEvents: ocultar ? "auto" : "none",
              zIndex: 2,
            }}
          >
            <DisenoChat
              misaventuras={misaventuras}
              amigos={amigos}
              funcion={seleccionarAmigo}
              selectaventura={elegirAventura}
              margin={0}
            />
          </Box>
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              transition: "opacity 0.5s ease",
              opacity: ocultar ? 0 : 1,
              pointerEvents: ocultar ? "none" : "auto",
              zIndex: 1,
            }}
          >
            {" "}
            {conversacion.chatgrupal ? (
              <VentanaChatGrupal
                datoschat={conversacion}
                datosaventura={aventuraSeleccionada}
              />
            ) : (
              <VentanaChat
                foto_amigo={amigoSeleccionado.foto_de_perfil}
                nombre_amigo={amigoSeleccionado.nombre}
                edad={amigoSeleccionado.fecha_de_nacimiento}
                actividades={amigoSeleccionado.actividades}
                foto_usuario={usuario.foto_de_perfil}
                conversacion={conversacion}
              />
            )}
          </Box>
        </Box>
      </Box>
    </ChatContext.Provider>
  );
}
